import React from 'react';

import { SvgProps } from '../enums';

export const FlagGL: React.FC<SvgProps> = ({ size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_270_55053"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="12"
    >
      <rect width="16" height="12" fill="white" />
    </mask>
    <g mask="url(#mask0_270_55053)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 6H16V12H0V6Z"
        fill="#C51918"
      />
      <mask
        id="mask1_270_55053"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="6"
        width="16"
        height="6"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 6H16V12H0V6Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_270_55053)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 10C8.20914 10 10 8.20914 10 6C10 3.79086 8.20914 2 6 2C3.79086 2 2 3.79086 2 6C2 8.20914 3.79086 10 6 10Z"
          fill="#F7FCFF"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0H16V6H0V0Z"
        fill="#F7FCFF"
      />
      <mask
        id="mask2_270_55053"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="6"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0H16V6H0V0Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask2_270_55053)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 10C8.20914 10 10 8.20914 10 6C10 3.79086 8.20914 2 6 2C3.79086 2 2 3.79086 2 6C2 8.20914 3.79086 10 6 10Z"
          fill="#C51918"
        />
      </g>
    </g>
  </svg>
);
